import { NavigateOptions, To } from "react-router-dom";

export const navigator: {
  nav: ((to: To, options?: NavigateOptions | undefined) => void) | undefined;
  mapId?: string;
} = {
  nav: undefined,
  mapId: undefined,
};
